import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map } from 'rxjs';
import { AuthFacade } from '@lyceo/shared/auth/data-access';
import { toObservable } from '@angular/core/rxjs-interop';

export function loginGuard(): CanActivateFn {
  return () => {
    const authFacade: AuthFacade = inject(AuthFacade);
    const router: Router = inject(Router);

    return toObservable(authFacade.isDoneLoading).pipe(
      filter((isDone) => isDone),
      map(() => {
        if (!authFacade.isAuthenticated()) {
          return true;
        }

        return router.createUrlTree(['/home']);
      }),
    );
  };
}
